import { createContext, useContext, useEffect, useState } from "react";
import { getToken, setToken, clearToken, getMe, adminLogin } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=admin
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const check = async () => {
      if (!getToken()) {
        setUser(false);
        setReady(true);
        return;
      }
      try {
        const me = await getMe();
        setUser(me);
      } catch {
        clearToken();
        setUser(false);
      } finally {
        setReady(true);
      }
    };
    check();
  }, []);

  const login = async (email, password) => {
    const { token, user: u } = await adminLogin(email, password);
    setToken(token);
    setUser(u);
    return u;
  };

  const logout = () => {
    clearToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
